"use strict";
/**
 * Do not edit directly
 * Generated on Thu, 19 Aug 2021 21:48:11 GMT
 */
exports.__esModule = true;
exports.BorderRadiusL = exports.BorderRadiusM = exports.BorderRadiusS = exports.BorderRadiusNone = exports.BorderThickL = exports.BorderThickM = exports.BorderThickS = exports.BorderDark = exports.BorderLight = void 0;
exports.BorderLight = "1px solid #a4b1b8";
exports.BorderDark = "1px solid #8a97a0";
exports.BorderThickS = "1px";
exports.BorderThickM = "2px";
exports.BorderThickL = "4px";
exports.BorderRadiusNone = "0px";
exports.BorderRadiusS = "3px";
exports.BorderRadiusM = "4px";
exports.BorderRadiusL = "8px";
